import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ListService } from '../../backend/api/list.service';
import { BasePagedComponent } from '../../core/components/base-paged/base-paged.component';
import { DialogService } from '../../core/dialog/dialog.service';
import { AuthService } from '../../core/services/auth.service';
import { ConfirmDialogComponent } from '../../shared/dialogs/confirm-dialog/confirm-dialog.component';
import { SaveListDialogComponent } from '../../shared/dialogs/save-list-dialog/save-list-dialog.component';
import { UntypedFormControl } from '@angular/forms';

interface ListRow {
  id: number;
  name: string;
  numberOfFamilies: number;
  date: any;
}

@Component({
  selector: 'app-lists',
  templateUrl: './lists.component.html',
  styleUrls: ['./lists.component.scss'],
})
export class ListsComponent extends BasePagedComponent implements OnInit {
  data: ListRow[] = [];
  searchQueryControl = new UntypedFormControl('');
  isLoading = false;

  constructor(
    private dialogService: DialogService,
    private listsService: ListService,
    authService: AuthService,
    t: TranslateService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;

    this.listsService
      .apiListGet({
        ...this.tableData,
        filter: JSON.stringify({
          search: this.searchQueryControl.value,
        })
      })
      .subscribe(
        (res) => {
          this.pageLoaded(res);
          this.isLoading = false;
          this.data =
            res.results?.map((x) => ({
              id: x.id || 0,
              name: x.name || '',
              numberOfFamilies: x.families?.length || 0,
              date: moment(x.date).format('MM/DD/YYYY')
            })) || [];
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  searchLists() {
    this.loadData();
  }

  new() {
    this.dialogService
      .open(SaveListDialogComponent, {
        size: 'lg',
        closeOnClickOutside: true,
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  edit(id: number) {
    this.dialogService
      .open(SaveListDialogComponent, {
        size: 'lg',
        closeOnClickOutside: true,
        data: {
          id,
        },
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  delete(id: number) {
    this.dialogService
      .open(ConfirmDialogComponent, {
        size: 'sm',
      })
      .afterClosed.subscribe((res) => {
        if (res?.confirmed) {
          this.listsService.apiListIdDelete({ id }).subscribe((res) => {
            this.loadData();
          });
        }
      });
  }
}
